/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Acceptance_P1Inputs */

const es_tyc_acceptance_p1 = /** @type {(inputs: Tyc_Acceptance_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al acceder o utilizar los servicios de Nexata (en adelante, "el Servicio"), usted acepta quedar vinculado por estos Terminos y Condiciones. Si no esta de acuerdo, no utilice el Servicio.`)
};

const en_tyc_acceptance_p1 = /** @type {(inputs: Tyc_Acceptance_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By accessing or using Nexata services (hereinafter, "the Service"), you agree to be bound by these Terms and Conditions. If you disagree, do not use the Service.`)
};

/**
* | output |
* | --- |
* | "By accessing or using Nexata services (hereinafter, \"the Service\"), you agree to be bound by these Terms and Conditions. If you disagree, do not use the Serv..." |
*
* @param {Tyc_Acceptance_P1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_acceptance_p1 = /** @type {((inputs?: Tyc_Acceptance_P1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Acceptance_P1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_acceptance_p1(inputs)
	return en_tyc_acceptance_p1(inputs)
});
export { tyc_acceptance_p1 as "tyc.acceptance.p1" }